import { Box, Grid } from "@mui/material";

import backgroundImgDesktop from "./components/media/BackgroundLogin.png";
import { Outlet } from "react-router-dom";

export const BasePagePublic = () => {
  return (
    <Box sx={{ height: "100vh", bgcolor: "#f8f8f8" }}>
      <Box sx={{ height: "100%" }}>
        <Grid container sx={{ height: "100%" }}>
          <Grid
            item
            xs={0}
            md={6}
            sx={{
              background: "#ececec50",
              borderRight: "1px solid #e3e3e3",
              p: 4,
              display: { xs: "none", md: "block" },
              flexDirection: "column",
              alignContent: "center",
            }}
          >
            <Box sx={{ textAlign: "center" }}>
              <Box
                component="img"
                src={backgroundImgDesktop}
                sx={{ width: "85%", height: "auto" }}
              />
            </Box>
          </Grid>

          <Grid
            item
            xs={12}
            md={6}
            sx={{
              height: "100%",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              borderRadius: { xs: "12px", md: 0 },
              p: 2,
              boxShadow: {
                xs: "0px 0px 10px rgba(97, 97, 97, 0.384)",
                md: "none",
              },
            }}
          >
            <Outlet />
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
};
